export default {
  data: () => ({
    level1: '1',
    level2: null,
    level3: null,
  }),
  mounted: function () {
    this.level1 = this.$el.dataset.level1
    this.level2 = this.$el.dataset.level2
    this.level3 = this.$el.dataset.level3
  },
  methods: {
    onChangeLevel1: function (event) {
      this.level2 = ''
      this.level3 = ''
    },
    onChangeLevel2: function (event) {
      this.level3 = ''
    }
  }
}
